/**
 * This script detects when native submit doesn't fire and falls back to direct redirect
 */
(() => {
  document.addEventListener('click', (e) => {
    const btn = e.target;
    if (btn.tagName !== 'INPUT' || btn.name !== 'checkout') return;

    const form = btn.closest('form');
    if (!form) return;

    let submitFired = false;

    form.addEventListener('submit', () => {
      submitFired = true;
    }, { once: true });

    // Submit event fires synchronously during click processing
    // If it hasn't fired by next tick, native submit was blocked - redirect directly
    setTimeout(() => {
      if (!submitFired) {
        window.location.href = '/checkout';
      }
    }, 0);
  }, true);
})();